/** @format */

import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MuiTable from "../../../common-utilities/core/mui-table";

const currencyFormatter = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
});

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const num = Number(value);
  return Number.isNaN(num) ? value : currencyFormatter.format(num);
};

// Column order matches the original Output sheet: Sr No | Category | Line Item |
// Tentative Capex | Contingency Amount | AOP.
const COLUMNS = [
  { label: "Sr No", id: "srNo", width: 80 },
  { label: "Category", id: "category" },
  { label: "Line Item", id: "lineItem" },
  // `render` (not valueConversionLogic) so displayValue is reachable -- a row can ask to be shown
  // as something other than its real tentativeCapex (e.g. "Add: Additional ceiling height" shows
  // "5%", not the ~96,222 it actually contributes to Total LHI - GC's sum).
  {
    label: "Tentative Capex",
    id: "tentativeCapex",
    render: (row) => formatCurrency(row.displayValue ?? row.tentativeCapex),
  },
  { label: "Contingency Amount", id: "contingencyAmount", valueConversionLogic: formatCurrency },
  { label: "AOP", id: "aop", valueConversionLogic: formatCurrency },
];

/**
 * Renders the computed Capex Calculator output (from POST /calculate or the last-saved
 * GET /:cfId). Shows a placeholder state until a calculation has actually been run.
 */
const CapexOutput = ({ outputLines = [] }) => {
  if (!outputLines.length) {
    return (
      <Paper
        variant="outlined"
        sx={{ p: 4, textAlign: "center", color: "text.secondary", borderStyle: "dashed" }}
      >
        <Typography variant="body2">
          Not calculated yet — fill in the Input Form above and click Save to view the projected
          Capex breakdown.
        </Typography>
      </Paper>
    );
  }

  const sortedLines = [...outputLines].sort((a, b) => a.srNo - b.srNo);

  return (
    <Box>
      <MuiTable
        columnsList={COLUMNS}
        dataList={sortedLines}
        pageCount={1}
        tableConfig={{ pagination: false, sorting: false }}
      />
    </Box>
  );
};

export default CapexOutput;
